import { cn } from "@omni/utils/styles";

import { CategoryAnchor } from "@/components/Navigation/Sidebar/components/assortiment/components/categoryLink";
import { useCategorySlideContext } from "@/components/Navigation/Sidebar/components/assortiment/components/categorySlide/context/categorySlide.context";

type Props = {
    className?: string;
};

export const Header = ({ className }: Props) => {
    const { category } = useCategorySlideContext();

    return (
        <CategoryAnchor
            category={category}
            className={cn("tw:font-bold tw:py-4", className)}
        />
    );
};
